import classes from './ContactForm.module.css'
import LibraryPhoto from '../img/library.jpg'
import Modal from "./Modal"

import { useRef } from 'react'
import { contactActions } from "../store"
import { useSelector, useDispatch } from "react-redux"

export default function ContactForm() {
    const formRef = useRef()
    const formSent = useSelector(state => state.formSubmitted)
    const dispatch = useDispatch();

    const closeContactForm = () => {
        dispatch(contactActions.closeContactForm())
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(contactActions.submitForm())
        setTimeout(() => {
            dispatch(contactActions.closeContactForm())
        }, 4000)
        console.log(formRef.current.value);
    }

    const form = <form onSubmit={handleSubmit}>
        <label>
            <span>Όνομα</span>
            <input type="text" placeholder='Πληκτρολογήστε το όνομα σας' name='name' ref={formRef}/>
        </label>
        <label>
            <span>Επώνυμο</span>
            <input type="text" placeholder='Πληκτρολογήστε το επώνυμο σας' name='lastName'/>
        </label>
        <label>
            <span>Τηλέφωνο</span>
            <input type="number" placeholder='Πληκτρολογήστε το τηλέφωνο επικοινωνίας' name='number'/>
        </label>
        <label>
            Μήνυμα
            <textarea name="message" cols="30" rows="4" placeholder='Κάντε μια σύντομη περιγραφή'></textarea>
        </label>
        <button className={classes['form-button']}>ΑΠΟΣΤΟΛΗ</button>
    </form>

    return (
        <Modal>
            <div className={classes.contact}>
                <div className={classes['contact-form']}>
                    {!formSent && form}
                    {formSent && <p>Έχουμε λάβει το μήνυμα σας, σύντομα θα επικοινωνήσουμε μαζί σας!</p>}
                    <button onClick={closeContactForm} className={classes['close-button']}>x</button>
                </div>
                <div className={classes['image-box']}>
                    <img src={LibraryPhoto} alt="Library Photo" />
                </div>
            </div>
        </Modal >
    )
}